// extracted by mini-css-extract-plugin
var _1 = "TableScrollButton-moduleTableScrollButton__gpq2V";
var _2 = "TableScrollButton-modulebutton__jexlR";
export { _1 as "TableScrollButton", _2 as "button" }
